export default __webpack_public_path__ + "static/media/icon_04_nativos.35f42396.svg";